if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        const sectionIds = this.cart ? this.cart.getSectionsToRender().map((section) => section.id) : null;
        const sectionsUrl = this.cart ? window.location.pathname : null;
        const engravingFeePayload = this.getEngravingFeePayload();
        const engravingFeeBody = engravingFeePayload
          ? this.buildEngravingFeeBody(engravingFeePayload, sectionIds, sectionsUrl)
          : null;
        const productVariantId = engravingFeeBody ? engravingFeeBody.items[0].id : this.variantIdInput.value;

        if (this.cart) this.cart.setActiveElement(document.activeElement);

        if (engravingFeeBody) {
          config.body = JSON.stringify(engravingFeeBody);
        } else {
          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append('sections', sectionIds);
            formData.append('sections_url', sectionsUrl);
          }
          delete config.headers['Content-Type'];
          config.body = formData;
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId,
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      getEngravingFeePayload() {
        if (!this.form.dataset.engravingFeePayload) return null;

        try {
          const payload = JSON.parse(this.form.dataset.engravingFeePayload);
          return payload && payload.feeVariantId ? payload : null;
        } catch {
          return null;
        }
      }

      getFormInputValue(name) {
        return this.form.querySelector(`[name="${name}"]`)?.value || '';
      }

      buildEngravingFeeBody(engravingFeePayload, sectionIds, sectionsUrl) {
        const feeVariantId = engravingFeePayload.feeVariantId;
        const mainVariantId = this.variantIdInput.value;

        if (!feeVariantId || !mainVariantId) return null;

        const quantity = parseInt(this.getFormInputValue('quantity'), 10) || 1;
        const mainItem = {
          id: mainVariantId,
          quantity,
        };
        const sellingPlan = this.getFormInputValue('selling_plan');
        const productTitle = engravingFeePayload.productTitle || '';
        const productSku = engravingFeePayload.productSku || '';
        const productVariantId = engravingFeePayload.productVariantId || mainVariantId;
        const productDetails = [];

        if (productSku) productDetails.push(`SKU: ${productSku}`);
        if (productVariantId) productDetails.push(`Variation ID: ${productVariantId}`);

        const forProduct = productDetails.length ? `${productTitle} (${productDetails.join(' / ')})` : productTitle;

        if (sellingPlan) mainItem.selling_plan = sellingPlan;

        const body = {
          items: [
            mainItem,
            {
              id: feeVariantId,
              quantity,
              properties: {
                'Font family': engravingFeePayload.fontFamily || '',
                'Lettering Count': engravingFeePayload.letteringCount || '',
                'Engraving text': engravingFeePayload.engravingText || '',
                'For product': forProduct,
              },
            },
          ],
        };

        if (sectionIds) body.sections = sectionIds;
        if (sectionsUrl) body.sections_url = sectionsUrl;

        return body;
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
